import React, { Component } from "react";
import PropTypes from "prop-types";
import { Loader } from "semantic-ui-react";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };
  }

  forgotPassword() {
    this.props.onForgotPassword();
  }

  login(e) {
    e.preventDefault();
    this.props.onLogin(this.state.username, this.state.password);
  }

  updateInputValue(e) {
    var change = {};
    change[e.target.id] = e.target.value;
    this.setState(change);
  }

  handleChange(e) {
    this.setState({ testServer: e.target.textContent });
  }

  renderError() {
    if (this.props.error)
      return (
        <div style={{ display: "flex", alignItems: "center", marginTop: 20 }}>
          <div
            style={{
              width: 400,
              fontFamily: "'Open Sans', sans-serif",
              boxSizing: "border-box",
              display: "block",
              marginLeft: "auto",
              paddingLeft: 40
            }}
          >
            {"* " + this.props.errorMessage}
          </div>
        </div>
      );

    return <div></div>;
  }

  config() {
    this.props.onConfig();
  }

  renderLogin() {
    if (this.props.isLoading || this.props.isLoggedIn) {
      return (
        <div
          style={{
            display: "flex",
            marginTop: 100,
            width: "600px",
            alignItems: "center"
          }}
        >
          <Loader
            active
            className="ui large home active text centered inline loader"
            size="large"
            style={{ color: "#fff" }}
            inline="centered"
          >
            Signing in
          </Loader>
        </div>
      );
    }

    var optionsData = [];

    optionsData.push({ text: "Production", value: "Production" });
    optionsData.push({ text: "Test", value: "Test" });

    let textColor = "#fff";
    //textColor = '#004c7e';

    let buttonBorder = "2px solid #dcecf7";
    //buttonBorder = '2px solid #1A6698'

    let buttonStyle = "lLogin";
    //buttonStyle = 'lLogin_falcona';

    let inputBg = "#e8f0fe";
    //inputBg = '#fff';

    let fcolor = "white";
    //fcolor = '#004c7e';

    return (
      <form onSubmit={this.login.bind(this)} style={{ fontFamily: "Arial" }}>
        {this.renderError()}
        <div style={{ display: "flex", alignItems: "center", marginTop: 20 }}>
          <label
            style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 16 }}
            for="login"
          >
            Login
          </label>
          <div
            style={{
              width: 400,
              boxSizing: "border-box",
              display: "block",
              marginLeft: "31.6406px",
              paddingLeft: 40
            }}
          >
            <input
              class="lInput"
              placeholder="Login"
              style={{
                fontFamily: "'Open Sans', sans-serif",
                width: "100%",
                height: 48,
                padding: "2px 10px",
                lineHeight: "1.65em",
                textIndent: ".571em",
                outline: 0,
                color: "black",
                borderRadius: 6,
                background: inputBg
              }}
              id="username"
              type="text"
              name="email"
              required=""
              onChange={e => this.updateInputValue(e)}
              validationmessage="Please enter Login"
            />
            <span class="k-invalid-msg" data-for="login"></span>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 20 }}>
          <label
            style={{ fontFamily: "'Open Sans', sans-serif", fontSize: 16 }}
            for="login"
          >
            Password
          </label>
          <div
            style={{
              width: 400,
              boxSizing: "border-box",
              display: "block",
              marginLeft: "auto",
              paddingLeft: 40
            }}
          >
            <input
              class="lInput"
              placeholder="Password"
              style={{
                fontFamily: "'Open Sans', sans-serif",
                width: "100%",
                height: 48,
                padding: "2px 10px",
                lineHeight: "1.65em",
                textIndent: ".571em",
                outline: 0,
                color: "black",
                borderRadius: 6,
                background: inputBg
              }}
              type="password"
              id="password"
              onChange={e => this.updateInputValue(e)}
              name="password"
              required=""
              validationmessage="Please enter Login"
            />
            <span class="k-invalid-msg" data-for="login"></span>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 20 }}>
          <div
            style={{
              width: 400,
              boxSizing: "border-box",
              display: "block",
              marginLeft: "auto",
              paddingLeft: 40
            }}
          >
            <a
              href="javascript:void()"
              onClick={this.forgotPassword.bind(this)}
              style={{ color: fcolor, fontFamily: "'Open Sans', sans-serif" }}
              class="lg is-fs-small has-line-on-hover"
            >
              Forgot password?
            </a>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", marginTop: 20 }}>
          <div
            style={{
              width: 400,
              position: "relative",
              boxSizing: "border-box",
              textAlign: "right",
              display: "block",
              marginLeft: "auto",
              paddingLeft: 40
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              onClick={this.config.bind(this)}
              class="gearHome"
              style={{
                position: "absolute",
                top: 12,
                left: 40,
                cursor: "pointer"
              }}
              width="20"
              height="20"
              color="rgb(220, 236, 247)"
              viewBox="0 0 54 54"
              id="settings"
            >
              <g fill="currentColor">
                <path d="M51.22 21h-5.052c-.812 0-1.481-.447-1.792-1.197s-.153-1.54.42-2.114l3.572-3.571a2.763 2.763 0 0 0 .814-1.966c0-.743-.289-1.441-.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933 0l-3.571 3.571c-.574.573-1.366.733-2.114.421A1.885 1.885 0 0 1 33 7.832V2.78A2.783 2.783 0 0 0 30.22 0h-6.44A2.783 2.783 0 0 0 21 2.78v5.052c0 .812-.447 1.481-1.197 1.792-.748.313-1.54.152-2.114-.421l-3.571-3.571c-1.052-1.052-2.883-1.05-3.933 0l-4.553 4.553a2.764 2.764 0 0 0-.814 1.967c0 .742.289 1.44.814 1.966l3.572 3.571c.573.574.73 1.364.42 2.114S8.644 21 7.832 21H2.78A2.783 2.783 0 0 0 0 23.78v6.439A2.783 2.783 0 0 0 2.78 33h5.052c.812 0 1.481.447 1.792 1.197s.153 1.54-.42 2.114l-3.572 3.571a2.763 2.763 0 0 0-.814 1.966c0 .743.289 1.441.814 1.967l4.553 4.553c1.051 1.051 2.881 1.053 3.933 0l3.571-3.572a1.887 1.887 0 0 1 2.114-.42c.75.311 1.197.98 1.197 1.792v5.052A2.783 2.783 0 0 0 23.78 54h6.439a2.783 2.783 0 0 0 2.78-2.78v-5.052c0-.812.447-1.481 1.197-1.792a1.885 1.885 0 0 1 2.114.42l3.571 3.572c1.052 1.052 2.883 1.05 3.933 0l4.553-4.553a2.764 2.764 0 0 0 .814-1.967c0-.742-.289-1.44-.814-1.966l-3.572-3.571c-.573-.574-.73-1.364-.42-2.114S45.356 33 46.168 33h5.052A2.783 2.783 0 0 0 54 30.22v-6.44A2.783 2.783 0 0 0 51.22 21zm.78 9.22c0 .43-.35.78-.78.78h-5.052a3.879 3.879 0 0 0-3.64 2.432 3.877 3.877 0 0 0 .854 4.294l3.572 3.571a.78.78 0 0 1 0 1.104l-4.553 4.553a.78.78 0 0 1-1.104 0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-.854A3.879 3.879 0 0 0 31 46.168v5.052c0 .43-.35.78-.78.78h-6.44c-.43 0-.78-.35-.78-.78v-5.052a3.879 3.879 0 0 0-2.432-3.64 3.985 3.985 0 0 0-1.533-.311c-1.014 0-1.997.4-2.761 1.164l-3.571 3.572a.78.78 0 0 1-1.104 0L7.046 42.4a.78.78 0 0 1 0-1.104l3.572-3.571a3.879 3.879 0 0 0 .854-4.294A3.88 3.88 0 0 0 7.832 31H2.78c-.43 0-.78-.35-.78-.78v-6.44c0-.43.35-.78.78-.78h5.052a3.879 3.879 0 0 0 3.64-2.432 3.877 3.877 0 0 0-.854-4.294l-3.572-3.571a.78.78 0 0 1 0-1.104l4.553-4.553a.78.78 0 0 1 1.104 0l3.571 3.571a3.88 3.88 0 0 0 4.294.854A3.876 3.876 0 0 0 23 7.832V2.78c0-.43.35-.78.78-.78h6.439c.431 0 .781.35.781.78v5.052c0 1.624.932 3.019 2.432 3.64a3.878 3.878 0 0 0 4.294-.854l3.571-3.571a.78.78 0 0 1 1.104 0l4.553 4.553a.78.78 0 0 1 0 1.104l-3.572 3.571a3.879 3.879 0 0 0-.854 4.294 3.879 3.879 0 0 0 3.64 2.432h5.052a.78.78 0 0 1 .78.779v6.44z"></path>
                <path d="M27 18c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm0 16c-3.859 0-7-3.141-7-7s3.141-7 7-7 7 3.141 7 7-3.141 7-7 7z"></path>
              </g>
            </svg>
            <input
              id="login_button"
              class={buttonStyle}
              onClick={this.login.bind(this)}
              type="submit"
              value="Login"
              style={{
                height: 44,
                borderRadius: 6,
                fontFamily: "'Open Sans', sans-serif",
                cursor: "pointer",
                border: buttonBorder,
                padding: "10px 20px",
                minWidth: "160px",
                color: textColor
              }}
            ></input>
          </div>
        </div>
      </form>
    );
  }

  render() {
    return (
      <div style={{ width: "100%" }} className="login">
        {this.renderLogin()}
      </div>
    );
  }
}

Login.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onLogin: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string.isRequired,
  onForgotPassword: PropTypes.func.isRequired,
  testServer: PropTypes.string.isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login/index.js